import Instructions from '../../../Block/SaleJetBlock/Partials/Cellular/Instructions/Instructions';
import React from 'react';
import TextList from '../../../Block/EsimUpgradeBlock/Partials/TextList/TextList';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import OrderSummarySucceededButton from './OrderSummarySucceededButton';
import './SuccessEsim.scss';

const SuccessEsim = (props) => {
    const isNiudAction = props.idfStore.lineType == 3;
    const lineNumber = props.idfStore.lineType == 1 ? props.idfStore.userDetails?.new_line_code : props.idfStore.lineNumber;
    const successPageTextList = isNiudAction
        ? props.EsimData.expandedValue[0].successPageEsimNiudTextList.value
        : props.EsimData.expandedValue[0].successPageEsimNewLineTextList.value;
    const headerText = isNiudAction ? 'ניוד והפעלת קו eSIM' : 'הפעלת קו eSIM';
    const btnText = isNiudAction ? 'קיבלתי את ה-SMS, בואו ננייד' : 'להפעלת ה-eSIM';

    return (
        <div className='idf-esim-success-page-wrapper'>
            <div className='idf-esim-success-page'>
                <div className='idf-esim-success-page__icon' />
                <div className='idf-esim-success-page__title'>מעולה, יש לך eSIM חדש!</div>

                <div className='idf-esim-success-page__details'>
                    <div className='idf-esim-success-page__phone'>
                        <span className='phone-number'>{lineNumber}</span>
                        <span className='phone-icon' aria-hidden='true' />
                    </div>
                    <div className='idf-esim-success-page__label'>{headerText}</div>
                </div>

                {isNiudAction && (
                    <div className='instructions-container'>
                        <Instructions details={props.EsimData.expandedValue[0].instructionsPageTextList.value} />
                    </div>
                )}
                {successPageTextList.length > 0 && <TextList textList={successPageTextList} />}

                <div className='idf-esim-success-page__buttons'>
                    <BtnSubmit
                        isBusiness={false}
                        text={btnText}
                        onclick={handlePageContinue}
                        formid='esim-block'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                    <div className='esimFinalBtnSubmit'>
                        <OrderSummarySucceededButton />
                    </div>
                </div>
            </div>
        </div>
    );

    function handlePageContinue() {
        window.location.href = props.idfStore.magicLink;
    }
};

export default SuccessEsim;
